import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import axios from 'axios';
import { apiUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";	

import { Editor } from '@toast-ui/react-editor';
import '@toast-ui/editor/dist/toastui-editor.css';

class Add extends Component {
	constructor(props)
	{
		// CheckAuth();
		super();	
		this.editorRef = React.createRef();
		this.state = {
			title:'',
			selectedOption:{ value: 'active', label: 'Active'},
			selectedTitle:{ value: '', label: 'Select Category'},
			selectedLinktoOption:{ value: '', label: 'Please select a link'},
			linkToOptions:[],
			
			selectedvalue:'active',
			description:'',	
			image_name:'',
			image_preview:'',
			selectedLinkToOption: null,
	         selectedLinkToValue: '',
			image:'',		
		};
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onEditorChangetext = this.onEditorChangetext.bind(this);		
	
    }
	componentDidMount() {

		var qs = require('qs');
			var postObject ={
					admin_id: localStorage.getItem('admin_id'),
		
			}
		 axios.post(apiUrl+"Promtdropdown/dropdownoptions",qs.stringify(postObject)).then(res => {
			  
			  if(res.data.status === 'success'){
				  this.setState({ linkToOptions: res.data.categorylist});
			  }
			}); 
	}
	handleChange = (r,selOption) => {       
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}		
		if(r=='title')
		{
			this.setState({  title : selOption.value});
		}
		 if (r == 'linkTo') {
			this.setState({
				selectedLinkToOption: selOption,
				selectedLinkToValue: selOption.value
			});
    		}
	};

   handleInputChange(event) {
      const {name, value} = event.target;  
		this.setState({
			[name]: value
			});		
  	}
	onEditorChangetext = () => {
		// Directly get HTML from editor (auto includes <p>, <br>)
		const html = this.editorRef.current.getInstance().getHTML();
		this.setState({description: html})
	
		// onSave(html); // Save directly to DB
	};
 
  
  handleSubmit = () => { 
	if(this.validateForm()){
	this.setState({Loading:true});
	const formdata = this.state;
	var qs = require('qs');
	var status = '';
	var link_to = '';


	if(formdata.selectedvalue === ''){
	status =formdata.selectedOption.value;
	}else{
	status = formdata.selectedvalue;
	}

	

	if(formdata.selectedLinkToValue === ''){
		link_to = formdata.selectedLinkToOption.value;
	}else{
		link_to = formdata.selectedLinkToValue;
	}



	var postObject ={
		admin_id: localStorage.getItem('admin_id'),
		title : formdata.title,
		priorty : formdata.priorty,
		link_to : link_to,
		status: status
	}
	let formData = new FormData();
	for (let k in postObject) {
		formData.append(k, postObject[k]);
	}
		

	axios.post(apiUrl+"Promtdropdown/add",formData).then(res => {
		if(res.data.status === "success"){
			this.setState({title:'',
				selectedOption:{ value: 'active', label: 'Active'},
				selectedTitle:{ value: '', label: 'Select Category'},
				selectedvalue:'active',
				description:'',	
				
				});
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
						setTimeout(
						function() {
							$('.success_message').html(this.props.history.push('/promtdropdownList'));
						}
						.bind(this),
						3000
						);
			}else{
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
				
				setTimeout(
				function() {
					$('.success_message').html('');
				}
				.bind(this),
				3000
				);
				this.setState({title:'',
			selectedOption:{ value: 'active', label: 'Active'},
			selectedTitle:{ value: '', label: 'Select Category'},
			selectedvalue:'active',
			description:'',	
			image_name:'',
			image_preview:'',
			image:'',Loading:false});
			}
		});
		
	}
  }

	validateForm() {
		const {title} = this.state;

		let errors = {};
		let formIsValid = true;

		if(!title){
			formIsValid = false;
			$('.errortitle').html('<span class="errorspan">Please fill the field</span>');
		}else{
			
			$('.errortitle').html('');
		}			
		this.setState({
			errors: errors
		});
		return formIsValid;
	}
	

	

  render() {	
	let preview = '';
	const {selectedOption,selectedTitle,selectedLinktoOption,linkToOptions,selectedLinkToOption} = this.state;	
    return (
      <div className="wrapper">  
	  <Header />
      <MenuSidebar currentpage="promtdropdownList" />  
	<div id="location-error"></div>
	<div className="content">	
		<div className="content-wrapper">
		<div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
			<div className="success_message"></div>
			<div>
				<a className="cursor-pointer btn-arrow" href="/promtdropdownList">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800.48 613.46"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(-1 0 0 -1 800.48 613.46)"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -199.77 906.72003)"><path d="m857.14 640.38-221.02 225.27-4.25-665.88-65.172 1.4141-1.418 667.3-223.85-226.68-48.172 48.172 306.02 310.27 307.44-311.69z" fillRule="evenodd"/></g></g></svg>
				</a>
			</div>
			<div className="title">
				<h4>Add Promt Dropdown</h4>				
			</div>
			 <form className="edit"  onSubmit={ e => { this.handleSubmit(this); e.preventDefault(); }}>
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Name<span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="text" name="title" onChange={this.handleInputChange} className="form-control" value={this.state.title}/>					
					
					<div className="errortitle"></div>
				</div>
				
				<div className="form-group">					
					<label>Status<span class="required" style={{ color: "red" }} > * </span> :</label>
					<Select 
						name="status"
						value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
						options={lang.common.status_option} 
						isSearchable = {false}
						onChange={this.handleChange.bind(this, 'status')}
					/>
	           </div> 

			</div>                  
			<div className="form-right">
				<div className="form-group">
					<label>Priority<span class="required" style={{ color: "red" }} > * </span>: </label>
					<input type="text" name="priorty" className="form-control" value={this.state.priorty}  onChange={this.handleInputChange} autoComplete="off" />
					<div className="error_priorty"></div>
				</div>
				<div className="form-group">					
						<label>Link To :</label>
						<Select 
							name="linkTo"
							value={selectedLinkToOption || { value: '', label: 'Please select a link' }}
							options={linkToOptions} 
							isSearchable={false}
							onChange={this.handleChange.bind(this, 'linkTo')}
						/>
					</div>
			</div>	
			</div>		
			<div className="btn-group export">	
				<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true?
                                        <span>Adding</span>:<span>Submit</span>
                                        }
			   </button>
			 
			</div>
			</form>
			</div>
				
		</div>	
	</div>
		 	
    </div>
    );
  }
}


export default (withRouter(Add));